module.exports = __webpack_public_path__ + "static/media/marketing_feature.3b7705f4.jpg";